(function($) {
    class NewsletterFormHandler {
        constructor() {
            this.$newsletterForm = $('.form--newsletter');
            this.$emailFormInput = this.$newsletterForm.find('#email');
            this.$checkboxInput = this.$newsletterForm.find('#terms');
            this.$submitButton = this.$newsletterForm.find('#newsletter_submit');
            this.$feedbackContainer = this.$newsletterForm.find('.form__checkbox');
            this.init();
        }

        init() {
            this.$submitButton.attr('disabled', 'disabled');
            this.handleEmailValidation();
            this.handleFormSubmission();
            this.handleCheckboxInteraction();
            this.handleOverlayClose();
        }

        handleOverlayClose() {
            $('.login-overlay__close').on('click', () => {
                $('.login-overlay').removeClass('login-overlay--show');
            });
        }

        validateEmail(email) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        }

        showError(message) {
            this.$feedbackContainer.attr('data-msg', message);
            this.$feedbackContainer.attr('data-msg-type', 'error');
        }

        clearError() {
            this.$feedbackContainer.attr('data-msg', '');
            this.$feedbackContainer.attr('data-msg-type', '');
        }

        handleEmailValidation() {
            this.$emailFormInput.on('input blur', () => {
                const email = this.$emailFormInput.val();

                if (this.validateEmail(email)) {
                    this.$submitButton.removeAttr('disabled');
                    this.clearError();
                } else {
                    this.showError('Molimo unesite valjanu e-mail adresu.');
                }
            });
        }

        handleFormSubmission() {
            this.$newsletterForm.on('submit', (event) => {
                event.preventDefault();
                const email = this.$emailFormInput.val();
                const termsAccepted = this.$checkboxInput.prop('checked');

                let isValid = true;

                if (!this.validateEmail(email)) {
                    this.showError('Molimo unesite valjanu e-mail adresu.');
                    isValid = false;
                    requestAnimationFrame(() => this.$emailFormInput.focus());
                }

                if (!termsAccepted) {
                    this.showError('Morate prihvatiti opće uvjete korištenja.');
                    this.$checkboxInput.focus();
                    this.highlightCheckboxError(this.$checkboxInput);
                    isValid = false;
                }

                if (isValid) {
                    const ajaxData = {
                        action: 'w4d_handle_newsletter_submission',
                        nonce: w4d_frontend_ajax.nonce,
                        email: email,
                        terms: 'gdpr'
                    };

                    $.post({
                        url: w4d_frontend_ajax.ajax_url,
                        data: ajaxData,
                        success: (response) => {
                            if (response.success) {
                                this.clearFormState();
                                this.showSuccess(response.data.message);
                            } else {
                                // Check if the error is due to "require login"
                                if (response.data.require_login) {
                                    // Show login overlay
                                    // $('.login-overlay').addClass('login-overlay--show');
                                    $('.w4d-header .dropdown').addClass('dropdown--overlay show');

                                    // Optionally, clear the form to prevent re-submission
                                    this.clearFormState();
                                } else {
                                    this.showError(response.data.message);
                                }
                            }
                        },
                        error: () => {
                            this.showError('Došlo je do pogreške u pretplati. Pokušajte ponovno.');
                        }
                    });
                }
            });
        }

        highlightCheckboxError($checkboxInput) {
            // Add a temporary error class to visually highlight the checkbox
            const $checkboxContainer = $checkboxInput.closest('.form__checkbox');
            $checkboxContainer.addClass('highlight-error');
        }

        handleCheckboxInteraction() {
            this.$checkboxInput.on('click', () => {
                const $checkboxContainer = this.$checkboxInput.closest('.form__checkbox');
                $checkboxContainer.removeClass('highlight-error');
            });
        }

        showSuccess(message) {
            this.$feedbackContainer.attr('data-msg', message);
            this.$feedbackContainer.attr('data-msg-type', 'success');
        }

        clearFormState() {
            this.$emailFormInput.val('');
            this.$checkboxInput.prop('checked', false);
            this.clearError();
        }
    }

    $(document).ready(() => {
        new NewsletterFormHandler();
    });
})(jQuery);